import Image from "next/image";

import { cn } from "@/lib/cn";

export function ModalCloseButton({
  onClick,
  className,
  ariaLabel = "Close",
}: {
  onClick: () => void;
  className?: string;
  ariaLabel?: string;
}) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "flex h-11 w-11 items-center justify-center transition-opacity hover:opacity-70",
        className
      )}
      aria-label={ariaLabel}
      type="button"
    >
      <Image
        src="/icons/x-icon.svg"
        alt=""
        width={18}
        height={18}
        style={{ filter: "opacity(0.8)" }}
      />
    </button>
  );
}
